module.exports = __webpack_public_path__ + "static/media/Funmi Sphri.417bf602.jpg";